module.exports = __webpack_public_path__ + "static/media/fee_btech.bbce3c70.pdf";